import { Chip } from '@mui/material';
import EmptyField from '../../../material/emptyField.component';
import { orgsFields } from '../../orgs.model';

function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}
const EnrollmentMethodField = ({ record = {} }) => {
    const enrollmentMethod = record[orgsFields.enrollmentMethod];

    if (
        !enrollmentMethod ||
        enrollmentMethod === 'n/a'
    ) {
        return <EmptyField />;
    }

    return (
        <Chip
            label={toTitleCase(enrollmentMethod)}
            size="small"
        />
    )
};

export default EnrollmentMethodField;